__turbopack_context__.v({
  "alert": "PlasmicNotice-module__GynPwq__alert",
  "alertnoCornerRadius": "PlasmicNotice-module__GynPwq__alertnoCornerRadius",
  "alertstatus_darkInfo": "PlasmicNotice-module__GynPwq__alertstatus_darkInfo",
  "alertstatus_error": "PlasmicNotice-module__GynPwq__alertstatus_error",
  "alertstatus_warning": "PlasmicNotice-module__GynPwq__alertstatus_warning",
  "icon": "PlasmicNotice-module__GynPwq__icon",
  "iconWrapper": "PlasmicNotice-module__GynPwq__iconWrapper",
  "iconstatus_darkInfo": "PlasmicNotice-module__GynPwq__iconstatus_darkInfo",
  "iconstatus_error": "PlasmicNotice-module__GynPwq__iconstatus_error",
  "iconstatus_warning": "PlasmicNotice-module__GynPwq__iconstatus_warning",
  "noticeWrapper": "PlasmicNotice-module__GynPwq__noticeWrapper",
  "noticeWrapperstretch": "PlasmicNotice-module__GynPwq__noticeWrapperstretch",
  "text": "PlasmicNotice-module__GynPwq__text",
  "textstatus_darkInfo": "PlasmicNotice-module__GynPwq__textstatus_darkInfo",
  "textstatus_error": "PlasmicNotice-module__GynPwq__textstatus_error",
  "textstatus_warning": "PlasmicNotice-module__GynPwq__textstatus_warning",
});
